import { render, staticRenderFns } from "./serveDetails.vue?vue&type=template&id=f483777a&scoped=true&"
import script from "./serveDetails.vue?vue&type=script&lang=js&"
export * from "./serveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f483777a",
  null
  
)

export default component.exports